import { render, staticRenderFns } from "./BussinessProcessButtons.vue?vue&type=template&id=7fdedfb4&scoped=true&"
import script from "./BussinessProcessButtons.vue?vue&type=script&lang=js&"
export * from "./BussinessProcessButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdedfb4",
  null
  
)

export default component.exports
import {QBtnDropdown} from 'quasar'
component.options.components = Object.assign({QBtnDropdown}, component.options.components || {})
